/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import { AxiosRequestConfig } from "axios";
import { SKIP_MESSAGE_SNACKBAR } from "../../constants/message";

//custom libraries
import {
  CSR_LOGINIDENTITY,
  METHOD,
  CSR_LOGOUTIDENTITY,
} from "../../constants/requests";
import { useRestService } from "./use-rest-service";

export const usePersonHandler = () => {
  const { executeRequest } = useRestService();

  const csrLogin = (logonId: string, logonPassword: string) => {
    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.POST,
      data: { email: logonId, password: logonPassword },
      url: CSR_LOGINIDENTITY,
      [SKIP_MESSAGE_SNACKBAR]: true,
    };

    return executeRequest(requestOptions);
  };

  const csrLoginAndChangePassword = (
    logonId: string,
    logonPassword: string,
    logonPasswordNew: string,
    logonPasswordVerify: string
  ) => {
    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.POST,
      data: { logonId, logonPassword, logonPasswordNew, logonPasswordVerify },
      url: CSR_LOGINIDENTITY,
      [SKIP_MESSAGE_SNACKBAR]: true,
    };
    return executeRequest(requestOptions);
  };
  const csrLogout = (csr: any) => {
    const { WCToken, WCTrustedToken } = csr;
    const requestOptions: AxiosRequestConfig | any = {
      method: METHOD.DELETE,
      url: CSR_LOGOUTIDENTITY,
      headers: {
        WCToken,
        WCTrustedToken,
      },
      [SKIP_MESSAGE_SNACKBAR]: true,
    };

    return executeRequest(requestOptions);
  };

  return {
    csrLogin,
    csrLogout,
    csrLoginAndChangePassword,
  };
};
